import { ClientOnly, createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { useEffect } from 'react'
import { cookieToInitialState } from 'wagmi'
import { Button } from '@/components/ui/button'
import { WalletConnectionButton } from '@/components/ui/wallet-connection-button'
import { WALLET_STATUS } from '@/constants/wallet-status'
import { useSiweSession } from '@/hooks/useSiweSession'
import { useWalletConnection } from '@/hooks/useWalletConnection'
import { wagmiAdapter } from '@/provider'

export const Route = createFileRoute('/_authenticated')({
	component: ProtectedLayout,
	beforeLoad: ({ location }) => {
		const init = cookieToInitialState(
			wagmiAdapter.wagmiConfig,
			document.cookie, // runs only in SPA mode
		)
		const hasSession = Boolean(init?.connections?.size)
		if (!hasSession) {
			throw redirect({
				to: '/',
				search: {
					redirect: location.href,
				},
			})
		}
	},
})

function ProtectedLayout() {
	const { status, updateUserInfo } = useWalletConnection()

	// Update user info when wallet status changes
	useEffect(() => {
		if (status === WALLET_STATUS.CONNECTED) {
			updateUserInfo()
			// Note: SIWE/SIWX authentication should be triggered manually by the user
			// to avoid infinite loops
		}
	}, [status, updateUserInfo])

	if (status === WALLET_STATUS.CONNECTING || status === WALLET_STATUS.RECONNECTING) {
		return (
			<div className="min-h-svh flex flex-col items-center justify-center gap-10 p-2">
				<div className="flex flex-col items-center gap-4">
					<h1 className="sm:text-4xl text-3xl font-bold">GaiaDEX</h1>
				</div>

				<ClientOnly
					fallback={
						<Button size="lg" className="w-fit" disabled>
							App Loading…
						</Button>
					}
				>
					<div className="max-sm:flex-col flex items-center gap-2">
						<WalletConnectionButton />
					</div>
				</ClientOnly>
			</div>
		)
	}

	updateUserInfo()

	return (
		<div className="min-h-screen flex flex-col">
			<main className="flex-1">
				<Outlet />
			</main>
		</div>
	)
}
